<template>
  <dialog-edit2 :value="value" @input="$emit('input')" :maxWidth="'800px'">
    <template v-slot:title> Профиль </template>
    <a-form-model2
      class="mt-1"
      v-model="data"
      :model="model"
      :modelForm="modelForm"
      :errors="errors"
      :config="{ dense: true, hideDetails: 'auto' }"
      @validate="
        // validate($event);
        doWatch($event)
      "
    />
    <template v-slot:actions>
      <a-btn-save @click="submit()" title="Сохранить" />
      <v-spacer />
      <v-btn @click="$emit('input')">Закрыть</v-btn>
    </template>
  </dialog-edit2>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess, genModel } from "@/components/mixings";
export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, getAccess, genModel],
  props: {
    value: Boolean,
  },
  data() {
    return {
      m: this.initModel(this.$store.getters["config/get"].models.profile, { values: this.$root.profile }),
      model: [],
      id: null,
      loaded: false,
      configForm: null,
    };
  },
  computed: {
    title() {
      return this.configForm?.title || this.m?.title || "";
    },
    config() {
      if (this.configForm?.head) return this.configForm.head;
      const type = this.configForm?.type || "default";
      return JSON.parse(JSON.stringify(this.m?.config?.[type] || {}));
    },
    api() {
      return this.m?.api || null;
    },
  },
  created() {
    this.updateData(this.id);
  },
  watch: {},
  methods: {
    async fetchData(id) {
      let data;
      if (this.$root.profile.role == 10) {
        id = this.$root.profile.clients[0]?.id;
        data = this.$root.profile.clients[0];
      }
      if (id) {
        this.loading = true;
        let response;
        try {
          response = await this.$axios.get(this.api + "/" + id);
          const data = response.data.data;
          for (const name in data) {
            if (name == "data") {
            }
            if (name == "data" && this.data?.data && data[name]) {
              for (const nameData in data.data) {
                this.$set(this.data.data, nameData, data.data[nameData]);
                this.$set(this.errors, nameData, null);
              }
            } else if (name == "data" && typeof this.data.data == "object") {
            } else {
              this.$set(this.data, name, data[name]);
              this.$set(this.errors, name, null);
            }
          }
        } catch (error) {}
        this.loading = false;

        this.afterFetchData(response);
      } else this.afterFetchData();
    },
    afterFetchData() {
      let t = 0;
      if (this.m?.config?.watch) {
        t = this.data?.[this.m.config.watch] || 0;
      }
      this.getModel(t);
      this.loading = false;
    },
    doWatch(e) {
      console.log("dowatch", e, this.m?.config?.watch);
      if (e == this.m?.config?.watch) this.getModel(this.data?.[e]);
    },
    getModel(t) {
      console.log("getModel");
      let config;
      const m = this.initModel(this.m, { values: this.$root.profile });

      if (t || t === 0) {
        if (m.config?.configField && this.m.config?.config && Array.isArray(m.config.config)) {
          config = m.config.config.find((el) => {
            if (Array.isArray(el.value)) return el.value.includes(this.data[m.config.configField]);
            return el.value == this.data[this.m.config.configField];
          });
        } else config = JSON.parse(JSON.stringify(m?.config?.[t] || this.config));
      }
      if (!config) config = this.m.config?.default;
      let model = this.calcModelConfig(config);
      if (true)
        model.forEach((el) => {
          if (el.hiddenCreate && !this.data?.id) {
            el.hidden = true;
          }
        });
      //  model = this.initModel(model, { values: this.$root.profile });
      this.model = model;
      this.fillFormFromModel(model);
      // this.inputData(this.initData);
    },
  },
};
</script>
